<template>
	<h2 class="heading">
		<slot />
	</h2>
</template>

<script>
export default {
    name: 'SectionHeading'
}
</script>

<style lang="scss" scoped>
.heading {
	font-size: 2.6rem;
	line-height: 1;
	font-weight: 700;
	margin-bottom: 25px;
}
</style>